import { DatePipe, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, ErrorHandler } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { MessageService } from 'primeng/api';
import { AppComponent } from './app/app.component';
import { setAppInjector } from './app/app.module';
import { routes } from './app/app-routing.module';
import { provideAuthConfig } from './app/authorization/auth-config.module';
import { ChunkErrorHandler } from './app/interceptor/ChunkErrorHandler';
import { ResultResponseInterceptor } from './app/interceptor/result-response.interceptor';
import { AppManagerService } from './app/services/app-manager.service';
import { DataService } from './app/services/data.service';
import { TriggersService } from './app/services/extension/triggers.service';
import { GenNotificheService } from './app/services/gennotifiche.service';
import { MessageAppService } from './app/services/message-app.service';
import { TranslateService } from './app/services/translate.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (environment.enableSentry) {
  Sentry.init({
    dsn: 'https://499ee7a9da704ec78ba1eb03bf8a20bf@sentry.scponline.it/5',
    integrations: [],
    ignoreErrors: [
      // Errore lanciato dall'estensione browser Angular DevTools su build di produzione, non dall'app
      'Angular debugging APIs are not available'
    ],
    // Ignora errori originati da estensioni del browser (non dall'app)
    denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//]
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    ...provideAuthConfig(),
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    DataService,
    AppManagerService,
    { provide: HTTP_INTERCEPTORS, useClass: ResultResponseInterceptor, multi: true },
    { provide: ErrorHandler, useClass: ChunkErrorHandler },
    MessageService,
    TranslateService,
    MessageAppService,
    DatePipe,
    DecimalPipe,
    GenNotificheService,
    TriggersService,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
  .then((appRef) => setAppInjector(appRef.injector))
  .catch((err) => console.error(err));
